
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReportDialog extends Serenity.EntityDialog<ECommSalesReportRow, any> {
        protected getFormKey() { return ECommSalesReportForm.formKey; }
        protected getIdProperty() { return ECommSalesReportRow.idProperty; }
        protected getLocalTextPrefix() { return ECommSalesReportRow.localTextPrefix; }
        protected getNameProperty() { return ECommSalesReportRow.nameProperty; }
        protected getService() { return ECommSalesReportService.baseUrl; }
        protected getDeletePermission() { return ECommSalesReportRow.deletePermission; }
        protected getInsertPermission() { return ECommSalesReportRow.insertPermission; }
        protected getUpdatePermission() { return ECommSalesReportRow.updatePermission; }

        protected form = new ECommSalesReportForm(this.idPrefix);

    }
}